import type { ItemsType } from "@/types/entities/legal";
import Tab from "@/components/ui/tab";
import type { ReactNode } from "react";
import { Button, Icon } from "@elaniintc/goes-design-system";

interface TabListProps {
  items: ItemsType[];
  children?: ReactNode;
  onClose: () => void;
  onSave: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const TabEditor = ({
  items,
  children = undefined,
  onClose,
  onSave,
  isLoading,
  isDisabled,
}: TabListProps) => {
  return (
    <div className="flex flex-col w-full">
      <ul className="relative flex justify-end p-3">
        <div className="flex flex-wrap absolute bottom-[-1px] left-3 z-20 pt-3">
          {items.map((item) => (
            <Tab
              key={item.label}
              active={item.isSelected}
              onClick={item.onClick}
              className="cursor-pointer"
            >
              {item.label}
            </Tab>
          ))}
        </div>
        <div className="flex gap-2">
          <Button
            variant="tertiary"
            className="py-1 px-2 cursor-pointer whitespace-nowrap border-neutral rounded-lg font-semibold text-body text-sm"
            onClick={onClose}
          >
            <span>Cancelar</span>
            <Icon type="fas" name="x" className="text-sm font-normal" />
          </Button>
          <Button
            variant="default"
            className="py-1 px-2 cursor-pointer rounded-lg"
            onClick={onSave}
            disabled={isLoading || isDisabled}
          >
            <span>Guardar</span>
            <Icon
              type="fas"
              name="floppy-disk"
              className="text-sm font-normal"
            />
          </Button>
        </div>
      </ul>
      {children}
    </div>
  );
};
